module.exports = __webpack_public_path__ + "img/noa_burnette_3.80c45da6.jpg";